<template>
  <aside
    class="z-[99999] shadow-xl h-full absolute bg-light-900 dark:bg-dark-800 w-72 transition-all duration-300 ease-in-out"
    :class="[isSidebarOpen ? 'translate-x-0' : '-translate-x-full']">
    <div id="sidebar_top"
      class="bg-light-900 dark:bg-dark-800 px-6 py-4 flex justify-between items-center border-b-2 border-primary dark:border-dark-500">
      <img src="/logo.webp" alt="Sendowo POS Logo" class="h-9 w-full object-contain" />
      <img src="/tulisan.webp" alt="Sendowo POS Logo" class="h-6 w-full object-contain" />
      <!-- <h3 class="text-xl font-extrabold text-primary dark:text-dark-50">SENDOWO</h3> -->
      <span id="close-sidebar"
        class="cursor-pointer p-2 hover:bg-primary-light dark:hover:bg-dark-700 rounded-lg transition-colors duration-200"
        @click="closeSidebar">
        <ArrowLeftIcon
          class="h-5 w-5 text-primary dark:text-primary transition-opacity duration-200 hover:opacity-90" />
      </span>
    </div>
    <div id="sidebar_main" class="overflow-y-auto px-4 py-7 max-h-[calc(100vh-100px)]">
      <template v-for="item in filteredMenuItems" :key="item.path">
        <RouterLink v-if="!item.children" :to="item.path" :id="item.id"
          class="mb-4 flex items-center px-3 py-2 rounded-lg text-light-100 dark:text-dark-50 hover:text-light-50 dark:hover:text-light-50 hover:bg-primary dark:hover:bg-dark-700 transition-all duration-200 group"
          :class="{
            'bg-light-50 dark:bg-dark-700 text-primary hover:text-light-100 dark:hover:text-light-50':
              isActive(item.path, item),
          }" @click="handleMenuItemClick">
          <component :is="item.icon"
            class="h-5 w-5 me-3 group-hover:metallic-gold-icon text-light-100 dark:text-dark-50 group-hover:text-light-50 dark:group-hover:text-dark-50 dark:group-hover:bg-dark-700"
            :class="{
              'text-primary dark:text-dark-50 group-hover:text-light-100 dark:group-hover:text-dark-50 dark:group-hover:bg-dark-700':
                isActive(item.path, item),
            }" />
          {{ item.name }}
        </RouterLink>
        <div v-else class="mb-4">
          <div
            class="flex items-center px-3 py-2 rounded-lg text-light-100 dark:text-dark-50 hover:text-light-50 dark:hover:text-light-50 hover:bg-primary dark:hover:bg-dark-700 transition-all duration-200 cursor-pointer group"
            @click="toggleMenu(item.id)">
            <component :is="item.icon"
              class="h-5 w-5 me-3 group-hover:metallic-gold-icon text-light-100 dark:text-dark-50 group-hover:text-light-50 dark:group-hover:text-dark-50 dark:group-hover:bg-dark-700"
              :class="{
                'text-white dark:text-dark-50 group-hover:text-light-100 dark:group-hover:text-dark-50 dark:group-hover:bg-dark-700':
                  isActive(item.path, item),
              }" />
            {{ item.name }}
            <ChevronDownIcon :id="`chevron-down-icon-${item.id}`"
              class="h-5 w-5 ml-auto transition-transform duration-200" :class="{ 'rotate-180': openMenus[item.id] }" />
          </div>
          <div v-show="openMenus[item.id]" class="pl-6">
            <RouterLink v-for="child in item.children" :key="child.path" :to="child.path" :id="child.id"
              class="flex mb-2 items-center px-3 py-2 rounded-lg text-light-100 dark:text-dark-50 hover:text-light-50 dark:hover:text-light-50 hover:bg-primary dark:hover:bg-dark-700 transition-all duration-200 group"
              :class="{
                'bg-light-50 dark:bg-dark-700 text-primary hover:text-light-100 dark:hover:bg-dark-700':
                  isActive(child.path, child),
              }" @click="handleMenuItemClick">
              <component :is="child.icon"
                class="h-5 w-5 me-3 group-hover:bg-primary text-light-100 dark:text-dark-50 group-hover:text-light-50 dark:group-hover:text-dark-50 dark:group-hover:bg-dark-700"
                :class="{
                  'text-primary dark:text-dark-50 group-hover:text-light-100 dark:group-hover:text-dark-50 dark:group-hover:bg-dark-700':
                    isActive(child.path, child),
                }" />
              {{ child.name }}
            </RouterLink>
          </div>
        </div>
      </template>
    </div>
    <div class="text-xs text-gray-500 dark:text-gray-400 px-3 py-1">
      Version: 2.1.2
    </div>
  </aside>
</template>

<script setup>
  import { ref, reactive, computed, watch, defineEmits, defineExpose, onMounted, onBeforeUnmount } from "vue";
  import {
    ArrowLeftIcon,
    HomeIcon,
    ClipboardDocumentListIcon,
    CubeIcon,
    ClockIcon,
    ClipboardDocumentCheckIcon,
    BuildingLibraryIcon,
    UsersIcon,
    ChevronDownIcon,
    InboxStackIcon,
    ChatBubbleLeftRightIcon,
    BookmarkSquareIcon,
    GiftIcon,
    Cog6ToothIcon,
    ListBulletIcon,
    BoltIcon,
    CircleStackIcon,
    ArrowTrendingUpIcon,
    ArrowUpOnSquareIcon,
    ArrowDownOnSquareIcon,
    ExclamationTriangleIcon,
    WrenchScrewdriverIcon,
    CurrencyDollarIcon,
    BackwardIcon,
    BookOpenIcon
  } from "@heroicons/vue/24/solid";
  import { useRoute } from "vue-router";

  const emit = defineEmits(["toggleBlur"]);

  const isSidebarOpen = ref(false);
  const openMenus = reactive({});
  const route = useRoute();
  const isBlur = ref(false);

  const menuItems = [
    {
      path: "/dashboard",
      name: "Beranda",
      id: "url-dashboard",
      icon: HomeIcon,
      permission: ["all"],
    },
    {
      path: "/master",
      name: "Master",
      id: "url-master",
      icon: InboxStackIcon,
      permission: ["1", "2", "3"],
      children: [
        {
          path: "/pelanggan",
          name: "Pelanggan",
          id: "url-customer",
          icon: UsersIcon,
          permission: ["1", "2", "3"],
        },
        {
          path: "/marketing",
          name: "Staff",
          id: "url-marketing",
          icon: ChatBubbleLeftRightIcon,
          permission: ["1", "2"],
        },
        {
          path: "/item",
          name: "Item",
          id: "url-item",
          icon: CubeIcon,
          permission: ["1", "2", "3", "4"],
        },
        {
          path: "/kategori-item",
          name: "Kategori Item",
          id: "url-kategori-item",
          icon: BookmarkSquareIcon,
          permission: ["1"],
        },
        {
          path: "/global-discount",
          name: "Global Discount",
          id: "url-global-discount",
          icon: GiftIcon,
          permission: ["1", "2"],
        },
        {
          path: "/unit",
          name: "Unit",
          id: "url-unit",
          icon: BuildingLibraryIcon,
          permission: ["1", "2"],
        },
      ],
    },
    {
      path: "/sales-return",
      name: "Retur Penjualan",
      id: "url-sales-return",
      icon: BackwardIcon,
      permission: ["1", "2"],
    },
    {
      path: "/cash-register",
      name: "Cash Register",
      id: "url-cash-register",
      icon: CurrencyDollarIcon,
      permission: ["1", "2"],
      children: [
        {
          path: "/cash-register",
          name: "Daftar Cash Register",
          id: "url-cash-register",
          icon: ListBulletIcon,
          permission: ["1", "2"],
        },
      ],
    },
    {
      path: "/stock",
      name: "Stok",
      id: "url-stock",
      icon: CircleStackIcon,
      permission: ["1", "2"],
      children: [
        {
          path: "/stock-opname",
          name: "Stok Opname",
          id: "url-stock-opname",
          icon: CircleStackIcon,
          permission: ["1", "2"],
        },
        {
          path: "/inbound-items-form",
          name: "Refill Stok",
          id: "url-inbound-items-form",
          icon: ArrowDownOnSquareIcon,
          permission: ["1", "2", "3"],
        },
        {
          path: "/outbound-items-form",
          name: "Barang Keluar",
          id: "url-outbound-items-form",
          icon: ArrowUpOnSquareIcon,
          permission: ["1", "2"],
        },
      ],
    },
    {
      path: "/riwayat",
      name: "Riwayat",
      id: "url-riwayat",
      icon: ArrowTrendingUpIcon,
      permission: ["1", "2"],
      children: [
        {
          path: "/riwayat-transaksi",
          name: "Riwayat Transaksi",
          id: "url-riwayat-transaksi",
          icon: ClockIcon,
          permission: ["1", "2"],
        },
        {
          path: "/hutang",
          // name: "Piutang",
          name: "Bon",
          id: "url-hutang",
          icon: ClockIcon,
          permission: ["1", "2"],
        },
      ],
    },
    {
      path: "/report",
      name: "Laporan",
      id: "url-report",
      icon: ClipboardDocumentListIcon,
      permission: ["1", "2"],
      children: [
        {
          path: "/report/daily-sales-order",
          name: "Laporan Harian",
          id: "url-report-daily-sales-object",
          icon: ClipboardDocumentCheckIcon,
          permission: ["1", "2"],
        },
        {
          path: "/report/all-sales-order",
          name: "Laporan Semua Transaksi",
          id: "url-report-all-sales-order",
          icon: ClipboardDocumentCheckIcon,
          permission: ["1", "2"],
        },
      ],
    },
    {
      path: "/panduan",
      name: "Panduan",
      id: "url-panduan",
      icon: BookOpenIcon,
      permission: ["all"],
    },
    {
      path: "/setting",
      name: "Pengaturan",
      id: "url-setting",
      icon: Cog6ToothIcon,
      permission: ["1", "2"],
      children: [
        {
          path: "/pengaturan",
          name: "Pengaturan",
          id: "url-setting",
          icon: WrenchScrewdriverIcon,
          permission: ["1"],
        },
        {
          path: "/user",
          name: "User",
          id: "url-user",
          icon: UsersIcon,
          permission: ["1", "2"],
        },
        {
          path: "/role",
          name: "Role & Permission",
          id: "url-role-permission",
          icon: ExclamationTriangleIcon,
          permission: ["0"],
        },
        {
          path: "/activity-log",
          name: "Activity Log",
          id: "url-activity-log",
          icon: BoltIcon,
          permission: ["0"],
        },
      ],
    },
  ];

  const isActive = (path, item) => {
    // For parent items, only check if current path matches
    if (item.children) {
      return route.path === path;
    }

    // For child items, check if current path matches
    return route.path === path;
  };

  const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value;
    toggleBlur();
  };

  const toggleBlur = () => {
    isBlur.value = isSidebarOpen.value;
    emit('toggleBlur', isBlur.value);

    // Add/remove overflow hidden from body when sidebar is open/closed
    if (isBlur.value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  const closeSidebar = () => {
    if (isSidebarOpen.value) {
      isSidebarOpen.value = false;
      toggleBlur();
    }
  };

  // Close sidebar when clicking on a menu item on mobile
  const handleMenuItemClick = () => {
    if (window.innerWidth < 768) { // Assuming 768px is your md breakpoint
      closeSidebar();
    }
  };

  // Close sidebar when clicking outside
  const handleClickOutside = (event) => {
    const sidebar = document.getElementById('sidebar');
    const sidebarToggle = document.getElementById('open-sidebar');

    if (!isSidebarOpen.value) return;

    const clickedOutsideSidebar = sidebar && !sidebar.contains(event.target);
    const clickedOutsideToggle = !(sidebarToggle && sidebarToggle.contains(event.target));

    if (clickedOutsideSidebar && clickedOutsideToggle) {
      closeSidebar();
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
    document.body.style.overflow = ''; // Reset overflow when component is unmounted
  });

  const toggleMenu = (id) => {
    openMenus[id] = !openMenus[id];
  };

  // Automatically open parent menus when child items are active
  watch(
    () => route.path,
    () => {
      menuItems.forEach((item) => {
        if (item.children) {
          const hasActiveChild = item.children.some(
            (child) => route.path === child.path
          );
          openMenus[item.id] = hasActiveChild;
        }
      });
    },
    { immediate: true }
  );

  const filteredMenuItems = computed(() => {
    const roleId = localStorage.getItem("role_id");

    const checkPermission = (item) => {
      // Check current item's permission
      const hasItemPermission =
        item.permission.includes(roleId) ||
        roleId == "null" ||
        item.permission.includes("all");

      // If item has no children, return its own permission
      if (!item.children || item.children.length === 0) {
        return hasItemPermission;
      }

      // Filter children with permission
      const filteredChildren = item.children.filter(
        (child) =>
          child.permission.includes(roleId) ||
          roleId == "null" ||
          child.permission.includes("all")
      );

      // Parent is only considered to have permission if it has children with permission
      return filteredChildren.length > 0;
    };

    return menuItems.filter((item) => {
      // If an item has children, filter its children
      if (item.children && item.children.length > 0) {
        item.children = item.children.filter(
          (child) =>
            child.permission.includes(roleId) ||
            roleId == "null" ||
            child.permission.includes("all")
        );
        item.permission = ['0'];
      }
      // Check permission for the item
      return checkPermission(item);
    });
  });

  // Expose methods to parent component
  defineExpose({
    toggleSidebar,
    closeSidebar,
    isSidebarOpen
  });
</script>

<style>
  .metallic-gold-icon {
    color: #b0112d;
    filter: drop-shadow(0 0 1px #ffd700);
  }

  .metallic-gold-text {
    background: linear-gradient(145deg, #ffd700, #d4af37, #b8860b);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  /* Add metallic gold background class */
  .bg-metallic-gold {
    background: linear-gradient(145deg, #ffd700, #d4af37, #b8860b);
    color: #d4af37;
  }

  /* Add active state styles for child items only */
  .menu-active {
    color: #b0112d !important;
  }

  .menu-active .metallic-gold-icon {
    color: linear-gradient(45deg, #b0112d, #900b23) !important;
  }
</style>